import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function saveRolesBonifications(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/roles`,
        body
    )
    console.log("response", response)
    return response?.data?.data
}